module.exports = __webpack_public_path__ + "b0f4db353a21928b379996a5dcff03f1.mp4";